// Builds the sticky-note list only from data the backend already returned.
// entries:     [{ key, label, score }], score = { points, maxPoints, subMinimumMet } | null
// docProgress: { [key]: { done, total } | null }
const ORDER = { submin: 0, data: 1, docs: 2 };

export const buildOutstanding = (entries, docProgress = {}) => {
  const items = [];
  entries.forEach(({ key, label, score }) => {
    if (!score) {
      items.push({ id: `${key}-data`, key, kind: 'data', text: `Upload the ${label} data sheet` });
    } else if (score.subMinimumMet === false) {
      items.push({ id: `${key}-submin`, key, kind: 'submin', text: `${label} is below its sub-minimum` });
    }
    const dp = docProgress[key];
    if (dp && dp.total > dp.done) {
      const n = dp.total - dp.done;
      items.push({ id: `${key}-docs`, key, kind: 'docs', text: `${n} verification document${n === 1 ? '' : 's'} outstanding for ${label}` });
    }
  });
  return items.sort((a, b) => ORDER[a.kind] - ORDER[b.kind]);
};
